import { render, staticRenderFns } from "./vivaWallet.vue?vue&type=template&id=3ebd92a1&scoped=true"
import script from "./vivaWallet.vue?vue&type=script&lang=js"
export * from "./vivaWallet.vue?vue&type=script&lang=js"
import style0 from "./vivaWallet.vue?vue&type=style&index=0&id=3ebd92a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd92a1",
  null
  
)

export default component.exports